const MINUTES_OCCURRENCE_JOIN_BUTTON_AVAILABLE_BEFORE_START_TIME = 60
const OCCURRENCE_DETAIL_PAGE_CONTENT_TOTAL_PADDING = 48

export {
  MINUTES_OCCURRENCE_JOIN_BUTTON_AVAILABLE_BEFORE_START_TIME,
  OCCURRENCE_DETAIL_PAGE_CONTENT_TOTAL_PADDING,
}
